import { useEffect, useRef, useState } from "react";
import Skeleton from "@mui/material/Skeleton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

const HEADER_ROW_HEIGHT = 50;
const TABLE_ROW_HEIGHT = 50;
const TABLE_FOOTER_HEIGHT = 32;
const CARD_HEIGHT = 270;

const RenderLoading = () => {
  const divRef = useRef<HTMLDivElement | null>(null);
  const [height, setHeight] = useState<number>(0);

  const updateHeight = () => {
    if (divRef.current) {
      setHeight(divRef.current.offsetHeight);
    }
  };

  const getCountSkeletons = () => {
    const usableHeight =
      height - HEADER_ROW_HEIGHT - TABLE_FOOTER_HEIGHT - CARD_HEIGHT;
    return Math.min(10, Math.floor(usableHeight / TABLE_ROW_HEIGHT));
  };

  useEffect(() => {
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return (
    <div ref={divRef} className="h-full flex flex-col">
      <div className="flex flex-col">
        <Skeleton
          className="m-1"
          sx={{ height: "30px", width: "70%" }}
          variant="rectangular"
        />
        <div className="flex justify-between items-center h-60 mb-2">
          <Skeleton
            className="mx-1"
            sx={{ height: "100%", width: "50%" }}
            variant="rectangular"
          />
          <Skeleton
            className="mx-1"
            sx={{ height: "100%", width: "50%" }}
            variant="rectangular"
          />
        </div>
      </div>
      <div className="mt-2 max-w-[900px] mx-auto">
        <TableContainer>
          <Table stickyHeader sx={{ width: "100%", tableLayout: "fixed" }}>
            <TableHead
              sx={{
                backgroundColor: "var(--color-table-header)",
                "& .MuiTableCell-head": {
                  backgroundColor: "var(--color-table-header)",
                },
              }}
            >
              <TableRow>
                <TableCell align="left" sx={{ width: "300px" }}>
                  <Skeleton variant="rectangular" />
                </TableCell>
                <TableCell align="center">
                  <Skeleton variant="rectangular" />
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ minWidth: "150px", width: "150px", maxWidth: "150px" }}
                >
                  <Skeleton variant="rectangular" />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.from({ length: getCountSkeletons() }).map((_, index) => (
                <TableRow key={`skeleton-${index}`}>
                  <TableCell>
                    <Skeleton variant="rectangular" />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="rectangular" />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="rectangular" />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter
              sx={{
                backgroundColor: "var(--color-table-header)",
              }}
            >
              <TableRow>
                <TableCell colSpan={3}></TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};
export default RenderLoading;
